import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { getBranchList } from "../Endpoint/Admin";
import {
  canAccessAllBranches,
  getSelectedBranchId,
  setSelectedBranchId,
} from "../services/PermissionService";

/**
 * Topbar branch switcher for GLOBAL admins (super admin / canAccessAllBranches).
 * Lets them view/manage a single branch's catalog or "All branches".
 * The selection is persisted (PermissionService) and sent as x-branch-id by the
 * global axios interceptor. Branch-scoped admins never see this control — they
 * are locked to their own branch server-side.
 */
class BranchSwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      branches: [],
      selectedId: getSelectedBranchId(),
    };
    this.toggle = this.toggle.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    if (!canAccessAllBranches()) return;
    getBranchList().then((res) => {
      if (res && res.success && Array.isArray(res.data)) {
        this.setState({ branches: res.data });
      }
    });
  }

  toggle() {
    this.setState((s) => ({ isOpen: !s.isOpen }));
  }

  handleSelect(branchId) {
    setSelectedBranchId(branchId);
    this.setState({ selectedId: branchId || null });
    // Reload so every page re-fetches its catalog data scoped to the new branch.
    window.location.reload();
  }

  currentLabel() {
    const { branches, selectedId } = this.state;
    if (!selectedId) return "All branches";
    const b = branches.find((x) => String(x._id) === String(selectedId));
    return b ? b.name : "All branches";
  }

  render() {
    if (!canAccessAllBranches()) return null;
    const { isOpen, branches, selectedId } = this.state;
    return (
      <Dropdown
        isOpen={isOpen}
        toggle={this.toggle}
        className="d-inline-block ml-1"
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn header-item waves-effect"
        >
          <i className="ri-store-2-line align-middle mr-1"></i>
          <span className="d-none d-xl-inline-block">{this.currentLabel()}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem
            active={!selectedId}
            onClick={() => this.handleSelect(null)}
          >
            All branches
          </DropdownItem>
          <DropdownItem divider />
          {branches.map((b) => (
            <DropdownItem
              key={b._id}
              active={String(selectedId) === String(b._id)}
              onClick={() => this.handleSelect(b._id)}
            >
              {b.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default BranchSwitcher;
